// CareLogix™ ORACLE — Phase 30 motion shared constants + helpers.
// Strictly additive. Premium dark-green / gold / black palette only.

export const PALETTE = Object.freeze({
  bgDeep:     "#040608",
  bgGreen:    "#0e3a2c",
  bgGreenLow: "rgba(14,58,44,0.55)",
  glassDark:  "rgba(11,15,20,0.92)",
  gold:       "#c5a059",
  goldBright: "#fde68a",
  goldGlow:   "rgba(197,160,89,0.45)",
  greenAccent:"#10b981",
  emerald:    "#22d3ee",
  amber:      "#fcd34d",
  red:        "#ef4444",
  violet:     "#a78bfa",
  slate1:     "#0b0f14",
  slate2:     "#1f2937",
  slate3:     "#cbd5e1",
  slate4:     "#94a3b8",
  slate5:     "#64748b",
});

export const BIAS_COLORS = Object.freeze({
  buy:   "#10b981",
  hold:  "#94a3b8",
  watch: "#22d3ee",
  avoid: "#ef4444",
});

export const RISK_COLORS = Object.freeze({
  low:    "#10b981",
  medium: "#fcd34d",
  high:   "#ef4444",
});

export const COMPLIANCE_FOOTER_LINE =
  "Research only · Not financial advice · Human decision required.";

export function scoreColor(score) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  if (s >= 80) return "#10b981";       // strong
  if (s >= 60) return "#fcd34d";       // moderate
  if (s >= 40) return "#fb923c";       // caution
  return "#ef4444";                     // weak
}

export function biasColor(bias) {
  return BIAS_COLORS[String(bias || "").toLowerCase()] || "#94a3b8";
}

export function riskColor(level) {
  return RISK_COLORS[String(level || "").toLowerCase()] || "#94a3b8";
}

// Build a deterministic pseudo-random sparkline so widgets that don't have
// live data still feel alive. Mocked, additive, and clearly research-only.
export function buildSparkline({ seed = "ORACLE", points = 32, base = 100, vol = 4 } = {}) {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) | 0;
  const out = [];
  let v = base;
  for (let i = 0; i < points; i += 1) {
    const r = ((Math.sin(h + i * 13.37) + Math.cos(h + i * 7.11)) / 2);
    v += r * vol;
    out.push(Number(v.toFixed(4)));
  }
  return out;
}

export function fmtNumber(v, digits = 2) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  return Number(v).toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });
}

export function fmtPct(v, digits = 2) {
  if (v == null || Number.isNaN(Number(v))) return "—";
  return `${Number(v).toFixed(digits)}%`;
}
